import type { QuestionCheckboxModelData } from '@coorum-research/shared-common/types/survey-json.type'
import type { Question } from 'survey-core'

import { SurveyQuestionAnswerSingleChoice } from './SurveyQuestionAnswerSingleChoice'

type Props = {
  question: Question
}

/**
 * answer 回答表示用のコンポーネント
 * question type === 'checkbox'
 */
export function SurveyQuestionAnswerCheckbox({ question }: Props) {
  const modelData = question.toJSON() as QuestionCheckboxModelData
  return (
    <>
      {Array.isArray(question.value) && question.value.length > 0
        ? (
          <ul className="list-inside list-disc">
          {question.value.map((v, index) => (
            <li key={index}>
              <SurveyQuestionAnswerSingleChoice
                rawValue={v}
                choices={modelData.choices}
                displayValue={question.getDisplayValue(true, v)}
              />
            </li>
          ))}
          </ul>
        )
        : <span className="text-gray-400">未選択</span>}
      {modelData.showCommentArea && question.comment.length > 0 && <div className="mt-2">{question.comment}</div>}
    </>
  )
}
